import React, { Component } from 'react';
import { BASE } from '../api/api'
import cachios from 'cachios'
import ReactHtmlParser from 'react-html-parser';
import Footer from '../footer/footerbkp';
import HeaderNew from '../header/header';

class ResearchCenters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            desc: ''
        }
    }

    componentWillMount() {
        cachios.get(BASE + 'jsonapi/node/page/ba42a5e0-2c71-4a76-800c-c8bb04da7996', {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                console.log(data.data.data, 'desc')
                this.topFunction()
                this.setState({
                    desc: data.data.data
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    render() {
        return (
            <div className='contact_rea res_cen'>
                <HeaderNew />
                <div className="body listing">
                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="container">
                                <h1 className="page-header">
                                    Research Centers
                                </h1>
                            </div>
                        </div>
                    </div>

                    <div className="main-content aboutcis">
                        <div className="container basicpage">
                            <div className="row">

                                {ReactHtmlParser(this.state.desc ? this.state.desc.attributes.body.processed : '')}

                            </div>
                        </div>
                    </div>

                </div>
                {/* <button onClick={()=>this.fn()}>print</button> */}
                <Footer />
            </div>
        )
    }
}


export default ResearchCenters;
